<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_018"><img alt="Image" src="images/f0012-01.jpg"/></a></p><a id="file_018">
<p class="caption">Grumman’s first big break came in the form of Model A floats for the Vought O2U Corsair observation plane. The float, equipped with wheels and arresting hook, made the aircraft a “go-anywhere” machine—on land, water, or the deck of a carrier. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_018.vue?83acc720